/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable func-names */
/* eslint-disable no-param-reassign */
import { useContext } from 'react';
import _ from 'lodash';
// eslint-disable-next-line import/no-unresolved
import LocaleConfig from 'locale-config';
import { useTranslator } from '@jutro/locale';
import { ViewModelServiceContext } from '@xengage/gw-portals-viewmodel-react';

const { name: nameConfig } = LocaleConfig;

function Person(data) {
    if (data) {
        _.extend(this, data);
        if (!data.firstName) {
            data.firstName = '';
        }
        if (!data.lastName) {
            data.lastName = '';
        }
    }
}

Person.prototype.append = function (sb, fieldId, value) {
    if (!_.isEmpty(value) && _.includes(nameConfig.visibleFields, fieldId)) {
        sb.push(value);
    }
};

Person.prototype.format = function (person, delimiter) {
    const lastName = person.lastNameKanji || person.lastName;
    const firstName = person.firstNameKanji || person.firstName;
    const { middleName } = person;
    const result = [];
    switch (nameConfig.formatMode) {
        case 'default':
            this.append(result, 'FirstName', firstName);
            this.append(result, 'MiddleName', middleName);
            this.append(result, 'LastName', lastName);
            break;
        case 'France':
            this.append(result, 'LastName', lastName);
            this.append(result, 'FirstName', firstName);
            break;
        case 'Japan':
            this.append(result, 'LastName', lastName);
            this.append(result, 'FirstName', firstName);
            break;
        case 'China':
            this.append(result, 'LastName', lastName);
            this.append(result, 'FirstName', firstName);
            break;
        default:
            break;
    }
    return result.join(delimiter);
};

Person.prototype.getDisplayName = function (defaultName) {
    return this.format(this, ' ') || defaultName || 'Unnamed';
};

Person.prototype.getFullName = function () {
    const translator = useTranslator();
    const viewModelService = useContext(ViewModelServiceContext);
    const suffixTypeList = viewModelService.productMetadata.get('pc').types.getTypelist('NameSuffix');

    const getTypeKeyDescription = (typeKeyName) => {
        return translator({
            id: typeKeyName,
            defaultMessage: typeKeyName
        });
    };
    const result = [];
    this.append(result, 'FirstName', this.firstName);
    this.append(result, 'MiddleName', this.middleName);
    this.append(result, 'LastName', this.lastName);
    if (this.suffix) {
        result.push(',');
        this.append(result, 'Suffix', getTypeKeyDescription(suffixTypeList.getCode(this.suffix).name));
    }

    return result.join(' ');
};

Person.createFromAccountContact = function (data) {
    const person = new this(data);
    person.emailAddress_ML = data.emailAddress1;
    return person;
};

Person.prototype.getFullNameWithoutSuffix = function () {
    const { lastName } = this;
    const { firstName } = this;
    const middleName = this.middleName || '';
    const result = [];
    this.append(result, 'FirstName', firstName);
    this.append(result, 'MiddleName', middleName);
    this.append(result, 'LastName', lastName);
    return result.join(' ');
};

export default Person;
